import React from 'react';
import ItemWithTooltip from './ItemWithTooltip';
import { ItemDotRedComponent } from '../../ItemDotRed';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

const DotRedItem: React.FC<Props> = ({ item, isSimple, isExpanded }) => (
  <ItemWithTooltip item={item}>
    <ItemDotRedComponent
      item={item}
      isSimple={isSimple}
      isExpanded={isExpanded}
    />
  </ItemWithTooltip>
);

export default DotRedItem;
